// extracted by mini-css-extract-plugin
export var container = "index-module--container--lX7UL";
export var description = "index-module--description--iRYP5";
export var gradBorder = "index-module--gradBorder--X0zlP";
export var imageContainer = "index-module--imageContainer--on6Od";
export var title = "index-module--title--fDhL-";